<template>
  <div class="access-block">
    <div class="access-block__guide">
      <h1>본 계정은 접속이 차단되었습니다.</h1>
      <p>해당 계정은 본 페이지에 접근할 수 없습니다.</p>

      <router-link to="/">
        <el-button class="default">
          기본 페이지로 이동
        </el-button>
      </router-link>

      <el-button 
        class="default access-block__logout"
        @click="handleClickLogout"
      >
        로그아웃
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccessBlock',
  methods: {
    async handleClickLogout() {
      try {
        await fiflboxApi.v1.postAccountsLogout();
      } catch (err) {
        console.log(err);
      }
      await this.$store.dispatch('timeTable/resetTimeTableInfos');
      await this.$tokenStorage.deleteToken();
      location.replace('');
    },
  },
};
</script>

<style lang="scss">
.access-block {
	width: 100%;
	height: 100%;
	background-size: cover;
	background-repeat: no-repeat;
	background-position-y: 0;
	background-image: url("//cdn.fiflbox.com/admin/expired-background-desktop.jpg");
	display: flex;
	align-items: center;
	justify-content: center;

	.access-block__guide {
		width: 400px;

		h1 {
			font-size: 24px;
			line-height: 36px;
			color: #202020;
			letter-spacing: -1.5px;
			text-align: center;
			margin-bottom: 15px;
		}

		p {
			line-height: 24px;
			font-size: 16px;
			color: #202020;
			letter-spacing: -0.8px;
			text-align: center;
		}

		.el-button {
			margin: 0;
		}
	}

	@media screen and (max-width: 768px) {
		background-image: url("//cdn.fiflbox.com/admin/expired-background-mobile.jpg");

		.access-block__guide {
			width: 260px;

			h1 {
				line-height: 29px;
				font-size: 20px;
				color: #202020;
				letter-spacing: -1.25px;
				text-align: center;
			}

			p {
				font-size: 15px;
				color: #202020;
				letter-spacing: -0.75px;
				text-align: center;
			}
		}
	}

	.el-button.access-block__logout {
		background-color: transparent;
		&:hover {
			background-color: rgba(0, 0, 0, 0.1);
		}
	}
}
</style>
